import { render, staticRenderFns } from "./NewDraggableComponent.vue?vue&type=template&id=e0c2a544"
import script from "./NewDraggableComponent.vue?vue&type=script&lang=js"
export * from "./NewDraggableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports